export default {
  ASSIGNED: 'ASSIGNED',
  STOCKED: 'STOCKED',
  PICKED_UP: 'PICKED_UP',
  RX_EXPIRED:'RX_EXPIRED',
  REMOVE_RX: 'REMOVE_RX',
  VERFIY_RX: 'VERFIY_RX',
  RX_HOLD: 'RX_HOLD',
  MANUAL_OVERRIDE:'MANUAL OVERRIDE',
  MOVE: 'MOVE',
  Ready: 'Ready',
  DELIVER: 'DELIVERED',
  COMPLETE: 'COMPLETED',
  RETURN: 'RETURNED',
  CANCEL: 'CANCEL',
  Out_for_Delivery: 'OUT_FOR_DELIVERY',
  ARRIVED: 'ARRIVED',
  REVERSE_PICKUP: 'REVERSE_PICKUP'
};



// WEBPACK FOOTER //
// ./src/components/common/event-type.js